import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-operation-service.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetOperationServiceDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metOperationServiceEntity = useAppSelector(state => state.metOperationService.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metOperationServiceDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metOperationService.detail.title">MetOperationService</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metOperationService.code">Code</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metOperationService.name">Name</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metOperationService.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metOperationService.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metOperationService.status">Status</Translate>
            </span>
          </dt>
          <dd>{metOperationServiceEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-operation-service" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-operation-service/${metOperationServiceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetOperationServiceDetail;
